import React from "react";
import { observer } from "mobx-react-lite";
import { Button, Flex, InputNumber, Tooltip } from "antd";
import { CustomParseFieldProps } from "@opendash/plugin-parse";
import { Icon } from "@opendash/icons";
import Input from "antd/lib/input/Input";
import { FestivalConfig } from "../../../parsegenerated";
import { EventSegment } from "../types";

type Props = CustomParseFieldProps<FestivalConfig>;

export const EventSegmentsCustomField = observer((props: Props) => {
  const [newName, setNewName] = React.useState("");
  const [newCount, setNewCount] = React.useState<number>(0);

  const [editingId, setEditingId] = React.useState<string | null>(null);
  const [editName, setEditName] = React.useState("");
  const [editCount, setEditCount] = React.useState<number>(0);

  const startEdit = (seg: EventSegment) => {
    setEditingId(seg.id);
    setEditName(seg.name);
    setEditCount(seg.attendeeCount);
  };

  const saveEdit = () => {
    props.setValue(
      (props.value ?? []).map((s: EventSegment) =>
        s.id === editingId ? { ...s, name: editName, attendeeCount: editCount } : s
      )
    );
    setEditingId(null);
  };

  const cancelEdit = () => setEditingId(null);

  const handleAdd = () => {
    const entry: EventSegment = {
      id: crypto.randomUUID(),
      name: newName,
      attendeeCount: newCount,
    };
    props.setValue(props.value ? [...props.value, entry] : [entry]);
    setNewName("");
    setNewCount(0);
  };

  const handleDelete = (id: string) => {
    props.setValue((props.value ?? []).filter((s: EventSegment) => s.id !== id));
  };

  return (
    <>
      {(props.value ?? []).map((seg: EventSegment) => {
        if (editingId === seg.id) {
          return (
            <Flex key={seg.id} align="center" gap={8} style={{ marginBottom: 6 }}>
              <Input
                value={editName}
                onChange={(e) => setEditName(e.target.value)}
                style={{ flex: 2 }}
                autoFocus
                onPressEnter={saveEdit}
              />
              <InputNumber
                value={editCount}
                onChange={(v) => setEditCount(v ?? 0)}
                min={0}
                style={{ flex: 1 }}
              />
              <Tooltip title="Speichern">
                <Button size="small" type="primary" onClick={saveEdit} disabled={!editName.trim()}>
                  <Icon icon="fa:check" />
                </Button>
              </Tooltip>
              <Tooltip title="Abbrechen">
                <Button size="small" onClick={cancelEdit}>
                  <Icon icon="fa:xmark" />
                </Button>
              </Tooltip>
            </Flex>
          );
        }
        return (
          <Flex key={seg.id} align="center" gap={8} style={{ marginBottom: 6 }}>
            <span style={{ flex: 1 }}>{seg.name}</span>
            <span style={{ color: "#888" }}>{seg.attendeeCount} Personen</span>
            {props.setValue && (
              <>
                <Tooltip title="Bearbeiten">
                  <Button size="small" onClick={() => startEdit(seg)}>
                    <Icon icon="fa:pen" />
                  </Button>
                </Tooltip>
                <Tooltip title="Löschen">
                  <Button size="small" danger onClick={() => handleDelete(seg.id)}>
                    <Icon icon="fa:trash" />
                  </Button>
                </Tooltip>
              </>
            )}
          </Flex>
        );
      })}
      {props.setValue && (
        <Flex align="center" gap={8} style={{ marginTop: 12 }}>
          <Input
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            placeholder="Name (z.B. Freitag)"
            style={{ flex: 2 }}
            onPressEnter={() => newName.trim() && handleAdd()}
          />
          <InputNumber
            value={newCount}
            onChange={(v) => setNewCount(v ?? 0)}
            placeholder="Personen"
            min={0}
            style={{ flex: 1 }}
          />
          <Button onClick={handleAdd} disabled={!newName.trim()}>
            <Icon icon="fa:plus" />
          </Button>
        </Flex>
      )}
    </>
  );
});
